"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _decorators = require("../utils/propTypes/decorators");

var getStyle = function getStyle(style, centerContent, width) {
  return centerContent ? Object.assign({}, style, {
    maxWidth: width
  }) : style;
};

var USE_CLASSES = {
  dark: '',
  light: 'private-overlay--light'
};

var UIOverlay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UIOverlay, _React$Component);

  function UIOverlay(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIOverlay);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIOverlay).call(this, props));

    _this.handleClick = function (evt) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(evt);
    };

    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    return _this;
  }

  (0, _createClass2.default)(UIOverlay, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          centerContent = _this$props.centerContent,
          children = _this$props.children,
          className = _this$props.className,
          contextual = _this$props.contextual,
          onClick = _this$props.onClick,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex,
          use = _this$props.use,
          width = _this$props.width,
          Inner = _this$props.Inner,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["centerContent", "children", "className", "contextual", "onClick", "style", "tabIndex", "use", "width", "Inner"]);
      var isSandboxed = contextual || this.context.sandboxed;
      var computedClassName = (0, _classnames.default)("private-overlay uiOverlay-backdrop", className, USE_CLASSES[use], isSandboxed && 'private-overlay--contextual');
      var computedChildrenWrapperClassName = centerContent ? 'private-modal__container' : "";
      var isClickable = onClick;
      var Overlay = isClickable ? _UIClickable.default : 'div';
      var overlayProps = isClickable ? {
        cursor: 'auto'
      } : undefined;
      return _react.default.createElement(Overlay, Object.assign({}, rest, overlayProps, {
        className: computedClassName,
        onClick: this.handleClick,
        role: "presentation",
        tabIndex: isSandboxed ? null : tabIndex
      }), _react.default.createElement(Inner, {
        className: computedChildrenWrapperClassName,
        ref: function ref(_ref) {
          _this2._innerEl = (0, _reactDom.findDOMNode)(_ref);
        },
        style: this._getStyle(style, centerContent, width)
      }, children));
    }
  }]);
  return UIOverlay;
}(_react.default.Component);

UIOverlay.propTypes = {
  centerContent: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  contextual: _propTypes.default.bool.isRequired,
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES)),
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  Inner: (0, _decorators.hidden)(_propTypes.default.elementType)
};
UIOverlay.contextTypes = {
  sandboxed: _propTypes.default.bool
};
UIOverlay.defaultProps = {
  centerContent: true,
  contextual: false,
  use: 'dark',
  Inner: 'div'
};
UIOverlay.displayName = 'UIOverlay';
var _default = UIOverlay;
exports.default = _default;
module.exports = exports.default;